import { atom } from "recoil";

const navigationNameAtom = atom({
  key: "navigationNameState",
  default: "",
});

export default navigationNameAtom;
